var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('product-content',{attrs:{"ajaxUrl":_vm.ajaxUrl,"dataUrl":_vm.dataUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }